<template>
 <div class="home">
    <App-navigation></App-navigation>
  
     <v-container grid-list-lg>

        <v-layout row>
            <v-flex  class="text-xs-center display-1 font-weight-black ">
              Available movies under {{category}}
                           </v-flex>
            <v-text-field
              v-model="search"
              prepend-icon="search"
              append-icon="mic"
              label="Search"
              solo-inverted
              class="mx-2"
              flat

            ></v-text-field>

            
        </v-layout>
        <v-layout row wrap>
            <v-flex class="text-xs-center display-3 font-weight-black my-3" >
              <v-data-table :headers="headers" :items="specific()" :search="search" :custom-filter="customFilter" hide-actions class="elevation-1">
                <template slot="items" slot-scope="{item}" >
                  <tr @click.stop="$set(dialogIma,item.image,true)" title="Click to view image and preview">
                <td><b>{{item.sn}}</b></td>
                  <td class="text-xs-center">{{item.movName.toUpperCase()}}</td>
                  <td class="text-xs-center">{{item.category.toUpperCase()}}</td>
                  <td class="text-xs-center">{{item.desc }}</td>
                  <td class="text-xs-center">{{item.useradd ? item.useradd : item.useredit }}</td>
                  <td class="text-xs-center">{{item.dateadded}}</td>
                  <td class="justify-center layout px-0">
                     <Edit-movie v-if="crc(staff.rights,'009')" :id="item.name" :link="item.link" :name="item.movName" :category="item.category" :desc="item.desc" :duration="item.duration"></Edit-movie>
                     <Delete-movie :name="item.name" :category="item.category" :movName="item.movName" v-if="crc(staff.rights,'003')"></Delete-movie>
                        
                  </td>
                  </tr>
                    <v-dialog v-model="dialogIma[item.image]" max-width="600px">
                  <v-card>
                    <v-card-title>
                      <span><b>EXTRA DETAILS FOR {{item.movName.toUpperCase()}}</b></span>

                    </v-card-title>
                    <v-card-text>
                       <v-tabs slot="extension" centered slider-color="brown" show-arrows>
                       <v-tab>Images</v-tab><v-tab>Preview</v-tab>
                       <v-tab-item>
                         <v-img :src="item.image"   height="500px">
                          <v-container fill-height fluid>
                            <v-layout fill-height>
                                <v-flex xs12 align-end flexbox>
                                    <span class="headline white--text" ><b></b></span>
                                </v-flex>
                            </v-layout>
                          </v-container>
                        </v-img>
                    <v-card-title primary-title>
                        <div>
                            <b>Name: {{item.movName.toUpperCase()}}  <br>
                            Duration: {{item.duration?item.duration:'Not Provided'}}  
                            </b> 
                        </div>
                    </v-card-title>


                       </v-tab-item>
                       <v-tab-item>
                         <video class="tab" width="550px" height="500px" controls> Preview is not supported
                           <source src="@/views/sample.mp4" /></video>
                       </v-tab-item>
                       
                       </v-tabs>
                     
                    </v-card-text>
                  </v-card>
                  
                  </v-dialog>
                  
                </template>
              </v-data-table>
              
            </v-flex>
        </v-layout>
        <Add-movie :category="category"></Add-movie>
     </v-container>
     
     
  </div>
</template>

<script>
// @ is an alias to /src
import AddMovie from '@/components/Movie/AddMovie.vue'
import AppNavigation from '@/components/Navigation/AppNavigation.vue'
import EditMovie from '@/components/Movie/EditMovie.vue'
import DeleteMovie from '@/components/Movie/DeleteMovie.vue'

import {checkright,specify} from '@/validator'

export default {
  name: 'movies',
  props: ['category'],
  data(){
      return {
          staff:this.$store.getters.getStaff,
          dialog:false,
          dialogIma:{},
          search:'',
          counter:0,
          headers:[
            { 
              text:'S/N',
              align:'center',
              sortable:true,
              value:'sn'
            },
            {
              text:'NAME',
              align:'center',
              sortable:true,
              value:'name'
            }, 
            {
              text:'CATEGORY',
              align:'center',
              sortable:true,
              value:'category'
            },
            {
              text:'DESCRIPTION',
              align:'center',
              sortable:true,
              value:'desc'
            },
            {
              text:'ADDED/EDITED BY',
              align:'center',
              sortable:true,
              value:'useradd'
            },
             {
              text:'DATE ADDED',
              align:'center',
              sortable:true,
              value:'dateadded'
            },
            {
              text:'ACTIONS',
              sortable:false,
             
            }
          ],
          listPrimitive:null
      }
  },
  methods:{
        loads(){
           
            let self=this;
            let value;
            self.$store.dispatch('updateMovies',false);
                   
           value = self.$store.getters.getMovie;
            //console.log(value);
            return value;
           
            
        },
      specific(){
        return specify(this.loads(),'category',this.category);
      },
    crc(array,value){
      return checkright(array,value);
    },
    customFilter(items,search){

     if(!search){ return items }
     function new_filter(val,search){
       return val !== null &&
        ['undefined','boolean'].indexOf(typeof val) === -1 &&
        val.toString().toLowerCase().replace( /[^0-9a-zA-Z]+/g ,'').indexOf(search) !== -1
     }

     let needleAry = search.toString().toLowerCase().split(" ").filter(x => x);

     return items.filter(row => needleAry.every(needle => Object.keys(row).some(key => new_filter(row[key],needle))));
    }
  },
  components: {
    AppNavigation,
    AddMovie,
    EditMovie,
    DeleteMovie,
    
  }
}
</script>
